import buildLoginUrl from 'core/initPage/check-for-redirects/utils/buildLoginUrl'
import renderAlert from 'pug/alert'
import getById from 'utils/DOM/getById'
import { ERRORS_MAP } from 'utils/NET/fetchJSONHandleError'
import setCounter from './setCounter'

const hideModal = () => {
  $('#emailQuoteSingular').modal('hide')
  const alertWrap = getById('alert-wrap')
  alertWrap.innerHTML = ''
}

function handleEmailResponse([contextResponse, emailResponse]) {
  if (emailResponse.error === ERRORS_MAP[401]) {
    renderAlert({
      id: 'email-alert',
      message:
        'We were unable to email this quote, it seems your session has expired. Please <strong>Log In</strong> and try again.',
      type: 'error',
      closeText: 'Log In',
      closeEvent: () => window.location.assign(buildLoginUrl(true))
    })
  } else if (emailResponse.error) {
    renderAlert({
      id: 'email-alert',
      message:
        'We were unable to email this quote. Please contact <a href="mailto:agentsupport@healthcare.com">agentsupport@healthcare.com</a>',
      type: 'error',
      closeText: 'Close',
      closeEvent: hideModal
    })
  } else {
    const waitSeconds = 2

    renderAlert({
      id: 'email-alert',
      message: 'Your quote has been sent successfully.',
      type: 'info',
      closeText: `This window will close in <span class="js-counter">${
        waitSeconds + 1
      }</span> seconds`,
      closeEvent: hideModal
    })
    setCounter(waitSeconds, hideModal, '.js-counter', 1000)
  }
}

export default handleEmailResponse
